import { Link } from 'react-router-dom';
import { FaChartLine, FaShieldAlt, FaBolt, FaTag, FaHome, FaBuilding, FaLeaf } from 'react-icons/fa';
import './why-choose-us.css';

const WhyChooseUs = () => {
    const propertyTypes = [
        {
            icon: <FaHome />,
            title: 'Residential Properties',
            description: 'Find your perfect home in prime locations across Amaravati',
            color: '#3b82f6',
            link: '/residential-plots-for-sale-in-amaravati'
        },
        {
            icon: <FaBuilding />,
            title: 'Commercial Spaces',
            description: 'Premium commercial properties for your business growth',
            color: '#10b981',
            link: '/commercial-plots-for-sale-in-amaravati'
        },
        {
            icon: <FaLeaf />,
            title: 'Agricultural Lands',
            description: 'High-value agricultural lands with excellent investment potential',
            color: '#f97316',
            link: '/agriculture-lands-for-sale-in-amaravati'
        }
    ];

    const features = [
        {
            icon: <FaChartLine />,
            title: 'Market Expertise',
            description: 'Deep understanding of Amaravati real estate market trends'
        },
        {
            icon: <FaShieldAlt />,
            title: 'Verified Properties',
            description: 'All properties are thoroughly verified with complete documentation'
        },
        {
            icon: <FaBolt />,
            title: 'Quick Process',
            description: 'Streamlined buying and selling process for faster transactions'
        },
        {
            icon: <FaTag />,
            title: 'Best Deals',
            description: 'Exclusive access to premium properties at competitive prices'
        }
    ];

    return (
        <section className="why-choose-us-section">
            <div className="container">
                <div className="section-header">
                    <h2>Why Choose Us</h2>
                    <p>Royale Spaces is Amaravati’s most trusted top real estate company, offering well-researched land and property opportunities in the Amaravati Capital Region. We specialize in open plots for sale in Amaravati, CRDA-approved second-phase land pooling ventures, and clear-title residential and commercial properties. From identifying the right investment plot in Amaravati to documentation and final registration, Royale Spaces provides complete end-to-end real estate consultancy services — ensuring a safe, transparent, and future-ready property investment in Amaravati, Andhra Pradesh</p>
                </div>

                <div className="features-grid">
                    {features.map((feature, index) => (
                        <div key={index} className="feature-card">
                            <div className="feature-icon">
                                {feature.icon}
                            </div>
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </div>
                    ))}
                </div>

                <div className="property-types-grid">
                    {propertyTypes.map((type, index) => (
                        <div key={index} className={`property-type-card card-${index + 1}`} style={{ color: type.color }}>
                            <div className="property-type-icon" style={{ background: type.color }}>
                                {type.icon}
                            </div>
                            <h3>{type.title}</h3>
                            <p>{type.description}</p>
                            <Link to={type.link} className="learn-more-link" style={{ color: type.color, borderColor: type.color }}>
                                Learn More →
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
